import React from 'react';
import {
  FileEarmarkSpreadsheetFill,
  FileEarmarkTextFill,
  FiletypePdf,
} from 'react-bootstrap-icons';
import { orderFileMediaKind } from '../../utils/orderFiles';

/**
 * Icon for an order file row (PDF, CSV, spreadsheet, or generic document).
 *
 * @param {{ row: Object, category?: 'po'|'receipt', size?: number }} props
 */
const OrderFilePreviewIcon = ({ row, category, size = 30 }) => {
  const kind = orderFileMediaKind(row, { category });

  if (kind === 'pdf') {
    return <FiletypePdf size={size} className="text-danger" />;
  }
  if (kind === 'csv' || kind === 'spreadsheet') {
    return <FileEarmarkSpreadsheetFill size={size} className="text-success" />;
  }
  return <FileEarmarkTextFill size={size} className="text-secondary" />;
};

export default OrderFilePreviewIcon;
